import * as bootstrap from 'bootstrap';

let activeAnnotation = null;

function elementsWithin(root, selector) {
  return [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];
}

function closeAnnotation(restoreFocus = false) {
  const trigger = activeAnnotation;
  if (!trigger) return;
  bootstrap.Popover.getInstance(trigger)?.hide();
  if (restoreFocus && trigger.isConnected) trigger.focus({ preventScroll: true });
}

function initBootstrapTriggers(root = document) {
  elementsWithin(root, '[data-bs-toggle="tooltip"]').forEach((element) => {
    bootstrap.Tooltip.getOrCreateInstance(element);
  });

  elementsWithin(root, '[data-bs-toggle="popover"]').forEach((element) => {
    if (bootstrap.Popover.getInstance(element)) return;
    if (!element.dataset.coaNoteTarget) {
      bootstrap.Popover.getOrCreateInstance(element);
      return;
    }

    bootstrap.Popover.getOrCreateInstance(element, {
      container: document.body,
      placement: 'auto',
      trigger: 'click',
      animation: false,
      html: true,
      title: () => {
        const title = document.createElement('span');
        title.textContent = element.dataset.coaNoteTitle;
        return title;
      },
      content: () => document.getElementById(element.dataset.coaNoteTarget)
        ?.querySelector('[data-coa-note-body]')?.innerHTML || '',
    });
    element.addEventListener('show.bs.popover', () => {
      if (activeAnnotation !== element) closeAnnotation();
      activeAnnotation = element;
      element.setAttribute('aria-expanded', 'true');
    });
    element.addEventListener('shown.bs.popover', () => {
      const popover = document.getElementById(element.getAttribute('aria-describedby'));
      if (!popover) return;
      popover.setAttribute('role', 'dialog');
      popover.setAttribute('aria-label', element.dataset.coaNoteTitle);
      popover.tabIndex = -1;
      // const close = document.createElement('button');
      // close.type = 'button';
      // close.className = 'btn btn-outline-secondary btn-sm d-block mt-2';
      // close.textContent = 'Close';
      // close.addEventListener('click', () => closeAnnotation(true));
      // popover.querySelector('.popover-body').append(close);
      popover.focus({ preventScroll: true });
    });
    element.addEventListener('hidden.bs.popover', () => {
      element.setAttribute('aria-expanded', 'false');
      if (activeAnnotation === element) activeAnnotation = null;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initBootstrapTriggers());
document.addEventListener('htmx:load', (event) => initBootstrapTriggers(event.detail.elt));
document.addEventListener('htmx:beforeCleanupElement', (event) => {
  elementsWithin(event.detail.elt, '[data-bs-toggle="tooltip"], [data-bs-toggle="popover"]')
    .forEach((element) => {
      if (activeAnnotation === element) activeAnnotation = null;
      bootstrap.Popover.getInstance(element)?.dispose();
      bootstrap.Tooltip.getInstance(element)?.dispose();
    });
});
document.addEventListener('click', (event) => {
  if (!activeAnnotation) return;
  const popover = document.getElementById(activeAnnotation.getAttribute('aria-describedby'));
  if (!activeAnnotation.contains(event.target) && !popover?.contains(event.target)) {
    closeAnnotation();
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && activeAnnotation) {
    event.preventDefault();
    closeAnnotation(true);
  }
});
